import React, { useState, useRef, useEffect } from "react";
import './inline-ai-prompt.css';
import { Button, Input, Col, Spin, Row } from 'antd';
import { SendOutlined, LoadingOutlined } from '@ant-design/icons';
import { getInlineAiPromptResponse } from './inlineai-prompt-api';

const InlineAiPrompt = ({ ProjectLanguage, handlePrompt, handleCodeAcceptHandler, handleRejectHandler, selectedTheme }) => {
  const [prompt, setPrompt] = useState("");
  const [showAccept, setShowAccept] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const textInput = useRef(null);

  const handlePromptChange = (e) => {
    setPrompt(e.target.value);
  };

  const handlePromptSubmit = async () => {
    if (ProjectLanguage && prompt) {
      const reqObj = {
        'language': ProjectLanguage,
        'instruction': prompt
      };

      setIsLoading(true);
      const response = await getInlineAiPromptResponse(reqObj);
      setIsLoading(false);
      if (response.data.statusCode === 200 && response.data.response) {
        const newCode = response.data.response.code;
        handlePrompt(newCode);
        setShowAccept(true);
      }
    }
  };

  const handleReject = (e) => {
    handleRejectHandler();
  };

  const handleAccept = () => {
    handleCodeAcceptHandler();
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter' && !isLoading) {
      handlePromptSubmit();
    }
  };

  useEffect(() => {
    if (textInput) {
      textInput.current.focus();
    }
  }, []);

  return (
    <>
      <div className={`inline-ai-container ${selectedTheme === 'light' ? 'light-theme' : 'dark-theme'}`}>
        <Col span={24}>
          <div className="inline-ai-prompt-wrapper">
            <div className="p-2">
              <Input 
                placeholder="Enter a prompt to generate new code" 
                onKeyDown={handleKeyDown} 
                size="small" 
                className="custom-input" 
                onChange={handlePromptChange}
                style={{
                  borderColor: '#0a58ca',
                  outline: 'none',
                  boxShadow: 'none',
                }}
                ref={textInput}
              />
              {!showAccept &&
                 <Row className="row-prop" justify="end">
                    <p style={{color:'#787D85'}}>Esc to close, Enter to submit </p>
                  { !isLoading &&
                    <span style={{color:'#787D85'}} className="send-btn" onClick={handlePromptSubmit}> &nbsp;<SendOutlined /></span>
                  }
                  {isLoading && <Spin indicator={<LoadingOutlined spin />} size="small" />}
                 </Row>
              }
            </div>

            {showAccept &&
            <Row justify="end">
              <div className="p-1">
                <Button className="monaco-btn mx-1" type="primary" onClick={handleReject}> Reject </Button>
                <Button className="monaco-btn mx-1" type="primary" onClick={handleAccept}> Accept </Button>
              </div>
            </Row>  
            }
          </div>
        </Col>
      </div>
    </>
  );
};

export default InlineAiPrompt;
